import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { PermissaoService } from '../services/permissao.service';
import { EnumPermissao } from '../enums/permissoes.enum';

@Directive({
  selector: '[appTemPermissao]',
  standalone: false
})
export class TemPermissaoDirective implements OnInit {
  @Input() appTemPermissao!: EnumPermissao | EnumPermissao[];
  @Input() appTemPermissaoElse?: TemplateRef<any>;
  
  private hasView = false;
  
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissaoService: PermissaoService
  ) { }
  
  ngOnInit(): void {
    this.updateView();
  }
  
  private updateView(): void {
    const permissions = Array.isArray(this.appTemPermissao) 
      ? this.appTemPermissao 
      : [this.appTemPermissao];
    
    const hasPermission = permissions.some(permission => {
        const result = this.permissaoService.hasPermission(permission);
        return result;
    });

    if (hasPermission && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasPermission && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
      if (this.appTemPermissaoElse) {
        this.viewContainer.createEmbeddedView(this.appTemPermissaoElse);
      }
    }
  }
}